import { categories } from '@/mocks/articles';

const comparisonRows = [
  { label: '内容难度', values: ['初级入门', '中级进阶', '高级专业'] },
  { label: '目标受众', values: ['零基础用户', '有一定基础用户', '资深从业者'] },
  { label: '内容类型', values: ['入门教程、基础知识科普', '深度分析、实战教程', '前沿研究、专家观点'] },
  { label: '更新频率', values: ['每日更新', '每周 3-5 篇', '每周 1-2 篇'] },
  { label: '阅读时间', values: ['5-15 分钟/篇', '15-30 分钟/篇', '30-60 分钟/篇'] },
  { label: '学习成本', values: ['低', '中等', '较高'] },
  { label: '交互深度', values: ['浅层浏览', '中度互动', '深度讨论'] },
];

export default function ComparisonTable() {
  const colorClasses = [
    'bg-accent-100 text-accent-700',
    'bg-primary-100 text-primary-700',
    'bg-secondary-100 text-secondary-700',
  ];

  return (
    <section className="w-full bg-background-100 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
            多维对比
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            一区二区三区 · 全面对比
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto leading-relaxed">
            从内容深度、适合人群、更新频率等多个维度，帮助您快速了解三个分区的核心差异，做出最适合的选择。
          </p>
        </div>

        <div className="overflow-x-auto rounded-2xl border border-background-200 bg-background-50">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-background-200">
                <th className="text-left px-6 py-4 font-semibold text-foreground-700 whitespace-nowrap">对比维度</th>
                {categories.map((cat, i) => (
                  <th key={cat.slug} className="px-6 py-4 text-center font-semibold whitespace-nowrap">
                    <span className={`inline-block px-4 py-1.5 rounded-full text-xs font-bold ${colorClasses[i]}`}>
                      {cat.name} · {cat.subtitle}
                    </span>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {comparisonRows.map((row, i) => (
                <tr key={row.label} className={i % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'}>
                  <td className="px-6 py-4 font-medium text-foreground-800 whitespace-nowrap">
                    {row.label}
                  </td>
                  {row.values.map((val, j) => (
                    <td key={j} className="px-6 py-4 text-center text-foreground-600">
                      {val}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}